import {gql} from '@apollo/client';

export const BCP_CHECK_RESULT_CODES = gql`
    query BcpCheckResultCodes {
        bcpCheckResultCodes {
            code
            description
        }
    }
`;
